import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import homesImage from '../assets/OurHomes/54.jpeg';

// Import home images
import home1Image from '../assets/OurHomes/13.379de8e606e79afc4b77.jpeg';
import home2Image from '../assets/OurHomes/2.7ba9c0c3f0139acb4f9e.jpeg';
import home3Image from '../assets/OurHomes/20.ddb2a9f184a44cdb487e.jpeg';
import home4Image from '../assets/OurHomes/17.34785f194cf488dae65c.jpeg';
import home5Image from '../assets/OurHomes/24.685ee26e65508f52eb76.jpeg';
import home6Image from '../assets/OurHomes/53.9f407a56ca1e47766709.jpeg';
import home7Image from '../assets/OurHomes/30.8929a7038dd4d0b0b45f.jpeg';
import home8Image from '../assets/OurHomes/WhatsApp Image 2025-05-03 at 17.617936608c4a80696fb2.jpeg';
import home9Image from '../assets/OurHomes/WhatsApp Image 2025-05-03 at 16.92237718fcdcb26761b7.jpeg';
import home10Image from '../assets/OurHomes/18.74495783c265482cc449.jpeg';


// Import modal images
import modalImage1 from '../assets/OurHomes/13.379de8e606e79afc4b77.jpeg';
import modalImage2 from '../assets/OurHomes/52.jpeg';
import modalImage3 from '../assets/OurHomes/10.jpeg';
import modalImage4 from '../assets/Gallery/1.jpeg';
import modalImage5 from '../assets/Gallery/2.jpeg';
import modalImage6 from '../assets/Gallery/21.jpeg';
import modalImage7 from '../assets/Gallery/20.jpeg';
import modalImage8 from '../assets/Gallery/29.jpeg';
import modalImage9 from '../assets/Gallery/16.jpeg';
import modalImage10 from '../assets/Gallery/14.jpeg';
import modalImage11 from '../assets/Gallery/16.jpeg';
import modalImage12 from '../assets/Gallery/26.jpeg';
import modalImage13 from '../assets/Gallery/25.jpeg';
import modalImage14 from '../assets/Gallery/53.jpeg';
import modalImage15 from '../assets/Gallery/35.jpeg';
import modalImage16 from '../assets/Gallery/33.jpeg';
import modalImage17 from '../assets/Gallery/31.jpeg';
import modalImage18 from '../assets/Home/WhatsApp Image 2025-05-03 at 17.jpeg';
import modalImage19 from '../assets/Home/WhatsApp Image 2025-05-03 at 16.jpeg';
import modalImage20 from '../assets/Home/18.jpeg';


const OurHomes = () => {
    const homesData = [
        {
            name: 'Marcsri Home',
            phone: '034-222 3363',
            location: '26, St. Sebastian\'s Road, Katukurunda, Kalutara',
            details: '57 Disabled children, adults, and Elderly Inmates',
            image: home1Image,
            modalTitle: 'MARCSRI HOME',
            modalDescription: 'This was started in 1983 January 29 by Rita Perera as Marcsri Sarana Sewa Niwahana. It was the origin of the blessed cluster of Marcsri homes now spread all over the Archdiocese of Colombo. A total of 56 are sheltered and cared for in this home. Inmates who are under the care of this house are either fully or partially mentally or physically disabled. Their expectations are not sky high, just the innocent thought that someone would visit them and provide a smile. Love, affection, and being cared for, is what they expect from the visitors. It\'s your charitable work and donations that keep these souls alive.',
            modalImages: [modalImage1, modalImage2, modalImage3],
            modalContact: 'Marc Sri Homes\nNo. 26, St. Sebastian\'s Road, Katutara, Kalutara\nTelephone: +94 34 2223 363,\n64 Differently abled children, adults and elderly inmates.'
        },
        {
            name: 'St. Theresa\'s Home',
            phone: '034-223 6654',
            location: '38, St. Sebastian\'s Road, Katukurunda, Kalutara',
            details: '25 Disabled young females',
            image: home2Image,
            modalTitle: 'ST. THERESA\'S HOME',
            modalDescription: 'Established to support disabled young females, St. Theresa\'s Home provides a safe and nurturing environment for 25 individuals. Our mission is to empower these young women through education, vocational training, and therapeutic activities. The home focuses on developing life skills and fostering independence while providing the necessary medical care and emotional support.',
            modalImages: [modalImage4, modalImage5],
            modalContact: 'St. Theresa\'s Home\n38, St. Sebastian\'s Road, Katukurunda, Kalutara\nTelephone: +94 34 223 6654\n25 Disabled young females'
        },
        {
            name: 'Marco Home',
            phone: '034-222 3969',
            location: 'Arthur Gunathilaka Mawatha, Kalamulla, Kalutara',
            details: '26 Disabled young females',
            image: home3Image,
            modalTitle: 'MARCO HOME',
            modalDescription: 'Marco Home specializes in caring for 26 disabled young females, offering comprehensive rehabilitation programs. Our facility includes physiotherapy units, special education classrooms, and recreational areas. We work closely with medical professionals to ensure each resident receives personalized care tailored to their specific needs and abilities.',
            modalImages: [modalImage6, modalImage7, modalImage8],
            modalContact: 'Marco Home\nArthur Gunathilaka Mawatha, Kalamulla, Kalutara\nTelephone: +94 34 222 3969\n26 Disabled young females'
        },
        {
            name: 'Mama Papa Home',
            phone: '034-223 6656',
            location: 'Sri Jayawardhanarama Mawatha, Kalamulla, Kalutara',
            details: '35 Disabled children',
            image: home4Image,
            modalTitle: 'MAMA PAPA HOME',
            modalDescription: 'Mama Papa Home provides family-style care for 35 disabled children, creating a warm and loving environment. Our approach combines therapeutic care with educational programs designed to help each child reach their full potential. The home features specialized facilities including sensory rooms, hydrotherapy pools, and adaptive playgrounds.',
            modalImages: [modalImage9, modalImage10, modalImage11],
            modalContact: 'Mama Papa Home\nSri Jayawardhanarama Mawatha, Kalamulla, Kalutara\nTelephone: +94 34 223 6656\n35 Disabled children'
        },
        {
            name: 'St. Mary\'s Home',
            phone: '034-222 6812',
            location: 'St. Mary\'s Road, Kuda Payagala',
            details: '45 Elderly homeless',
            image: home5Image,
            modalTitle: 'ST. MARY\'S HOME',
            modalDescription: 'St. Mary\'s Home offers compassionate care for 45 elderly homeless individuals, providing them with dignity in their golden years. Our facility includes comfortable living quarters, medical care units, and communal spaces for social activities. We focus on creating a family atmosphere where residents can find companionship and peace.',
            modalImages: [modalImage12, modalImage13],
            modalContact: 'St. Mary\'s Home\nSt. Mary\'s Road, Kuda Payagala\nTelephone: +94 34 222 6812\n45 Elderly homeless'
        },
        {
            name: 'St. Albert\'s Home',
            phone: '034-227 6047',
            location: 'Polkotuwa, Galle Road, Beruwala',
            details: '25 Elderly',
            image: home6Image,
            modalTitle: 'ST. ALBERT\'S HOME',
            modalDescription: 'St. Albert\'s Home specializes in geriatric care for 25 elderly residents, offering medical support and engaging activities. Our programs include memory care for those with dementia, physical therapy sessions, and various recreational activities to keep residents active and socially connected.',
            modalImages: [modalImage14],
            modalContact: 'St. Albert\'s Home\nPolkotuwa, Galle Road, Beruwala\nTelephone: +94 34 227 6047\n25 Elderly'
        },
        {
            name: 'St. Anne\'s Home',
            phone: '038-229 5251',
            location: 'Mervyn Cooray Mawatha, Wadduwa',
            details: '18 Elderly',
            image: home7Image,
            modalTitle: 'ST. ANNE\'S HOME',
            modalDescription: 'St. Anne\'s Home provides personalized care for 18 elderly residents in a serene coastal setting. Our facility offers private rooms, beautiful gardens, and a dedicated staff that provides round-the-clock care. We emphasize quality of life through personalized care plans that address each resident\'s physical, emotional, and social needs.',
            modalImages: [modalImage15, modalImage16, modalImage17],
            modalContact: 'St. Anne\'s Home\nMervyn Cooray Mawatha, Wadduwa\nTelephone: +94 38 229 5251\n18 Elderly'
        },
        {
            name: 'St. Martin\'s Home',
            phone: '011-229 0048',
            location: 'Caithan Mawatha, Kotugoda, Ja-Ela',
            details: '30 Disabled young females',
            image: home8Image,
            modalTitle: 'ST. MARTIN\'S HOME',
            modalDescription: 'St. Martin\'s Home supports 30 disabled young females through comprehensive care programs. Our facility includes residential wings, therapy centers, and vocational training units. We focus on skill development and social integration, preparing our residents for as much independence as possible.',
            modalImages: [modalImage18],
            modalContact: 'St. Martin\'s Home\nCaithan Mawatha, Kotugoda, Ja-Ela\nTelephone: +94 11 229 0048\n30 Disabled young females'
        },
        {
            name: 'Cardinal Cooray Home',
            phone: '076-423 2115',
            location: 'Angalamark Estate, Halkandawila',
            details: '20 Disabled young males',
            image: home9Image,
            modalTitle: 'CARDINAL COORAY HOME',
            modalDescription: 'Cardinal Cooray Home specializes in caring for 20 disabled young males, focusing on their physical and emotional development. Our programs include adaptive sports, vocational training, and life skills education. The home features accessible facilities and a staff trained in special needs care.',
            modalImages: [modalImage19],
            modalContact: 'Cardinal Cooray Home\nAngalamark Estate, Halkandawila\nTelephone: +94 76 423 2115\n20 Disabled young males'
        },
        {
            name: 'Mendis Home',
            phone: '077-792 2009',
            location: 'Kinsey Road, Colombo 08',
            details: '08 Elderly men',
            image: home10Image,
            modalTitle: 'MENDIS HOME',
            modalDescription: 'Mendis Home provides intimate, personalized care for 8 elderly men in a comfortable residential setting. Our small size allows us to offer highly individualized attention to each resident. We focus on maintaining independence while providing the necessary support for daily living and healthcare needs.',
            modalImages: [modalImage20],
            modalContact: 'Mendis Home\nKinsey Road, Colombo 08\nTelephone: +94 77 792 2009\n08 Elderly men'
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedHome, setSelectedHome] = useState(null);
    const [visibleCount, setVisibleCount] = useState(3);

    // Handle responsive card count
    useEffect(() => {
        const updateVisibleCount = () => {
            if (window.innerWidth < 576) setVisibleCount(1);
            else if (window.innerWidth < 992) setVisibleCount(2);
            else setVisibleCount(3);
        };

        updateVisibleCount();
        window.addEventListener('resize', updateVisibleCount);
        return () => window.removeEventListener('resize', updateVisibleCount);
    }, []);

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - visibleCount + homesData.length) % homesData.length);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + visibleCount) % homesData.length);
    };

    const getVisibleHomes = () => {
        return Array.from({ length: visibleCount }, (_, i) =>
            homesData[(currentIndex + i) % homesData.length]
        );
    };

    const handleReadMore = (home) => {
        setSelectedHome(home);
        setShowModal(true);
        document.body.style.overflow = 'hidden';
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedHome(null);
        document.body.style.overflow = 'auto';
    };

    return (
        <div className="p-3 p-md-5 p-lg-10 text-center">
            <section className="container">
                {/* Existing Section (Left-Right Layout) */}
                <div className="row justify-content-center align-items-center mb-4 mb-md-5">
                    {/* On mobile, image comes first */}
                    <div className="col-12 d-md-none mb-4">
                        <img
                            src={homesImage}
                            alt="Marcsri Homes building exterior"
                            className="img-fluid rounded shadow-sm"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </div>

                    {/* Left Side - Text Content */}
                    <div className="col-md-6 text-start mb-4 mb-md-0 order-md-1">
                        <h1 className="mb-3 mb-md-4 text-dark" style={{ fontSize: '3em', fontFamily: 'Georgia' }}>Our Homes</h1>
                        <p className="text-muted">
                            Marcsri Homes, established in 1942, is a premier provider of quality housing solutions in Sri Lanka. With a legacy spanning over eight decades, we specialize in creating comfortable, sustainable, and affordable homes for families across the country.
                        </p>
                        <p className="text-muted d-none d-md-block">
                            Located in the heart of Colombo and expanding to regions like Kalutara, Marcsri Homes combines modern architecture with traditional craftsmanship. Our dedication to customer satisfaction and community development has made us a trusted name in the real estate industry, offering innovative living spaces that cater to diverse needs and lifestyles.
                        </p>
                    </div>

                    {/* Right Side - Image (hidden on mobile) */}
                    <div className="col-md-6 d-none d-md-block order-md-2">
                        <img
                            src={homesImage}
                            alt="Marcsri Homes building exterior"
                            className="img-fluid rounded shadow-sm"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </div>
                </div>

                {/* New Section - Image Cards Carousel */}
                <div className="row justify-content-center mb-4 mb-md-5">
                    <div className="col-12">
                        <h2 className="mb-3 mb-md-4 text-dark" style={{ fontSize: '3em', fontFamily: 'Georgia' }}>Our Home Locations</h2>

                        {/* Desktop Carousel */}
                        <div className="d-none d-md-flex align-items-center justify-content-center">
                            <button
                                className="btn btn-outline-dark mx-2"
                                onClick={handlePrev}
                                aria-label="Previous homes"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {'<'}
                            </button>

                            <div className="d-flex flex-wrap justify-content-center gap-3" style={{ flex: 1 }}>
                                {getVisibleHomes().map((home, index) => (
                                    <div key={index} className="card" style={{
                                        width: '100%',
                                        maxWidth: '350px',
                                        border: '1px solid #dee2e6',
                                        borderRadius: '8px'
                                    }}>
                                        <div className="card-body text-start">
                                            <h5 className="card-title text-dark text-center" style={{ fontSize: '1.2em' }}>{home.name}</h5>
                                            <img
                                                src={home.image}
                                                alt={`${home.name} building exterior`}
                                                className="card-img-top img-fluid rounded"
                                                style={{ height: '180px', objectFit: 'cover' }}
                                            />
                                            <p className="card-text mt-2 text-muted" style={{ fontSize: '0.9em' }}>
                                                <strong>Location:</strong> {home.location}<br />
                                                <strong>Details:</strong> {home.details}<br />
                                                <strong>Phone:</strong> {home.phone}
                                            </p>
                                            <button
                                                className="btn btn-primary mt-2 w-100"
                                                onClick={() => handleReadMore(home)}
                                                style={{ fontSize: '0.9em' }}
                                            >
                                                Read More
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <button
                                className="btn btn-outline-dark mx-2"
                                onClick={handleNext}
                                aria-label="Next homes"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {'>'}
                            </button>
                        </div>

                        {/* Mobile Carousel */}
                        <div className="d-flex d-md-none align-items-center justify-content-center">
                            <button
                                className="btn btn-outline-dark mx-2"
                                onClick={handlePrev}
                                aria-label="Previous homes"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {'<'}
                            </button>

                            <div style={{ width: '70%' }}>
                                {getVisibleHomes().map((home, index) => (
                                    <div key={index} className="card" style={{
                                        width: '100%',
                                        border: '1px solid #dee2e6',
                                        borderRadius: '8px'
                                    }}>
                                        <div className="card-body text-start">
                                            <h5 className="card-title text-dark text-center" style={{ fontSize: '1.2em' }}>{home.name}</h5>
                                            <img
                                                src={home.image}
                                                alt={`${home.name} building exterior`}
                                                className="card-img-top img-fluid rounded"
                                                style={{ height: '180px', objectFit: 'cover' }}
                                            />
                                            <p className="card-text mt-2 text-muted" style={{ fontSize: '0.9em' }}>
                                                <strong>Location:</strong> {home.location}<br />
                                                <strong>Details:</strong> {home.details}<br />
                                                <strong>Phone:</strong> {home.phone}
                                            </p>
                                            <button
                                                className="btn btn-primary mt-2 w-100"
                                                onClick={() => handleReadMore(home)}
                                                style={{ fontSize: '0.9em' }}
                                            >
                                                Read More
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <button
                                className="btn btn-outline-dark mx-2"
                                onClick={handleNext}
                                aria-label="Next homes"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {'>'}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Modal for Home Details */}
                {showModal && selectedHome && (
                    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        overflowY: 'auto',
                        zIndex: 1050
                    }}>
                        <div
                            className="modal-dialog modal-lg"
                            role="document"
                            style={{
                                maxWidth: '90%',
                                margin: '20px auto',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                            }}
                        >
                            <div
                                className="modal-content"
                                style={{
                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                    border: 'none',
                                }}
                            >
                                <div
                                    className="modal-header border-0"
                                    style={{
                                        padding: '15px 20px',
                                        position: 'relative',
                                        background: 'transparent',
                                    }}
                                >
                                    <h5
                                        className="modal-title text-dark"
                                        style={{
                                            fontSize: '1.5em',
                                            fontWeight: '600',
                                            fontFamily: 'Georgia',
                                            color: '#2c3e50',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {selectedHome.modalTitle}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseModal}
                                        aria-label="Close"
                                        style={{
                                            position: 'absolute',
                                            right: '15px',
                                            top: '15px',
                                            fontSize: '1em',
                                            opacity: '0.7',
                                            transition: 'opacity 0.2s ease',
                                        }}
                                        onMouseOver={(e) => e.target.style.opacity = '1'}
                                        onMouseOut={(e) => e.target.style.opacity = '0.7'}
                                    ></button>
                                </div>
                                <div
                                    className="modal-body text-start"
                                    style={{
                                        padding: '20px',
                                        fontSize: '1em',
                                        lineHeight: '1.6',
                                        color: '#34495e',
                                    }}
                                >
                                    <p style={{ marginBottom: '15px', color: '#34495e' }}>
                                        {selectedHome.modalDescription}
                                    </p>
                                    <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
                                        {selectedHome.modalImages.map((image, index) => (
                                            <img
                                                key={index}
                                                src={image}
                                                alt={`${selectedHome.name} building exterior`}
                                                className="img-fluid rounded"
                                                style={{
                                                    maxWidth: '100%',
                                                    width: '220px',
                                                    height: 'auto',
                                                    border: '2px solid #e9ecef',
                                                    borderRadius: '8px',
                                                    transition: 'transform 0.3s ease',
                                                }}
                                                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                                                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                                            />
                                        ))}
                                    </div>
                                    <p
                                        className="mt-3"
                                        style={{
                                            color: '#34495e',
                                            fontSize: '0.9em',
                                            fontStyle: 'italic',
                                            whiteSpace: 'pre-line'
                                        }}
                                    >
                                        {selectedHome.modalContact}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </section>
        </div>
    );
};

export default OurHomes;